var map = {
	"./2.png": "chPc",
	"./Frame 1312318390@2x(7).png": "E362",
	"./Frame 1312318390@2x.png": "qSwv",
	"./bg_drak.png": "tzdb",
	"./bg_draw.png": "UMOJ",
	"./bg_goods.png": "aNUY",
	"./bg_pop.png": "I3i/",
	"./bg_rank.png": "f2Mm",
	"./bg_rules.png": "JjlB",
	"./btn_1.png": "C5k6",
	"./btn_2.png": "JZUM",
	"./btn_3.png": "tIaa",
	"./btn_4.png": "4iNx",
	"./btn_again.png": "o/hE",
	"./btn_back.png": "oK1L",
	"./btn_close.png": "Dbwr",
	"./btn_drak.png": "BsiQ",
	"./btn_index_line.png": "EVAd",
	"./btn_list_cxlq.png": "Q75b",
	"./btn_list_lq.png": "SAYk",
	"./btn_ok.png": "tHnT",
	"./btn_rules.png": "NtV3",
	"./btn_share.png": "LdxD",
	"./chevron-left@2x.png": "zmxr",
	"./icon_go.png": "a6IK",
	"./index_bottom.png": "Dijg",
	"./info_top.png": "mbg2",
	"./logo_w.png": "ubEf",
	"./pop_goods.png": "3hY8",
	"./pop_title.png": "Bb+z",
	"./rank_top.png": "s/YE",
	"./text_center.png": "yTG3",
	"./text_right.png": "E2ek",
	"./title_index.png": "mdc/",
	"./to_share.png": "QfCZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ih+";


//////////////////
// WEBPACK FOOTER
// ./src/assets \.(png|jpe?g|gif|svg|mp4)$
// module id = 9ih+
// module chunks = 1